
export const DB_CONECT = 'https://t5f1805b29d37b001382761af.herokuapp.com';
export const DB_CONECT_FAKE = 'https://planet-time-linseed.glitch.me';
export const PRODUCT_ALL = 'PRODUCT_ALL';